// removed by extract-text-webpack-plugin
module.exports = {"box":"box--3075f","invalidMessage":"invalidMessage--2ac4a"};